import { render, staticRenderFns } from "./SelectCriterionType.vue?vue&type=template&id=3a37b3b7&"
import script from "./SelectCriterionType.vue?vue&type=script&lang=ts&"
export * from "./SelectCriterionType.vue?vue&type=script&lang=ts&"
import style0 from "./SelectCriterionType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports